var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 240,
    viewBox: "0 0 206 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1670_4550)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.3113 38.3968C86.3113 29.1798 93.7831 21.708 103 21.708C112.217 21.708 119.689 29.1798 119.689 38.3968V38.8615C139.134 45.7345 153.066 64.2797 153.066 86.0789V122.371H153.347C153.347 122.371 153.411 130.708 158.982 130.708C161.081 130.708 163.305 131.56 165.261 132.622C169.218 134.77 171 139.266 171 143.769C171 152.725 163.739 159.986 154.783 159.986H50.8518C42.0971 159.986 35 152.889 35 144.134C35 139.429 37.0048 134.785 41.1664 132.59C43.1504 131.543 45.3125 130.708 47.1626 130.708C50.1586 130.708 51.9695 127.666 52.9338 125.257V86.0789C52.9338 64.2797 66.8657 45.7345 86.3113 38.8615V38.3968ZM102.5 190.208C113.822 190.208 123 185.619 123 179.958C123 174.297 113.822 169.708 102.5 169.708C91.1782 169.708 82 174.297 82 179.958C82 185.619 91.1782 190.208 102.5 190.208Z",
    fill: "url(#paint0_linear_1670_4550)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1670_4550)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 156.6,
    cy: 162.308,
    r: 17.6,
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M156.509 168.357C159.559 168.357 161.373 165.856 161.373 161.886C161.373 157.916 159.542 155.458 156.509 155.458C153.466 155.458 151.627 157.933 151.627 161.895C151.627 165.874 153.449 168.357 156.509 168.357ZM156.509 166.544C154.824 166.544 153.862 164.825 153.862 161.886C153.862 158.999 154.841 157.271 156.509 157.271C158.167 157.271 159.138 158.99 159.138 161.895C159.138 164.834 158.184 166.544 156.509 166.544Z",
    fill: "url(#paint1_linear_1670_4550)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88 111.22C88 112.017 88.4749 112.735 89.2232 113.01C91.6316 113.895 97.2269 115.708 102.65 115.708C108.059 115.708 113.468 113.905 115.803 113.017C116.537 112.738 117 112.028 117 111.243C117 109.807 115.508 108.808 114.146 109.264C111.398 110.185 107.016 111.362 102.577 111.362C98.102 111.362 93.6266 110.165 90.8386 109.242C89.4801 108.792 88 109.789 88 111.22Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80 93.7443C80 93.1748 80.2223 92.6263 80.6546 92.2555C81.7193 91.3421 83.9231 89.7081 86.0622 89.7081C88.2103 89.7081 90.3583 91.3558 91.3819 92.2669C91.792 92.6319 92 93.1614 92 93.7104C92 95.6611 89.3502 96.7707 87.4779 96.2234C87.0058 96.0854 86.5197 96.0031 86.032 96.0031C85.5172 96.0031 85.0023 96.0948 84.5025 96.2469C82.6298 96.8169 80 95.7019 80 93.7443Z",
    fill: "#383938"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114 93.7443C114 93.1748 114.222 92.6263 114.655 92.2555C115.719 91.3421 117.923 89.7081 120.062 89.7081C122.21 89.7081 124.358 91.3558 125.382 92.2669C125.792 92.6319 126 93.1614 126 93.7104C126 95.6611 123.35 96.7707 121.478 96.2234C121.006 96.0854 120.52 96.0031 120.032 96.0031C119.517 96.0031 119.002 96.0948 118.503 96.2469C116.63 96.8169 114 95.7019 114 93.7443Z",
    fill: "#383938"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M34.5532 59.1525C32.6123 48.3835 41.201 35.6478 51.2571 33",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M18.6345 54.8539C16.122 40.9136 27.2399 24.4275 40.2573 21",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1670_4550",
    x: 0,
    y: 0.708008,
    width: 206,
    height: 238.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 14
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.208044 0 0 0 0 0.283314 0 0 0 0 0.429427 0 0 0 0.057 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1670_4550"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1670_4550",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1670_4550",
    x: 131,
    y: 138.708,
    width: 51.1992,
    height: 51.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.411765 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1670_4550"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1670_4550",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1670_4550",
    x1: 171,
    y1: 21.708,
    x2: 10.6466,
    y2: 162.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC916"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB516"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1670_4550",
    x1: 162.5,
    y1: 151.108,
    x2: 144.429,
    y2: 162.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC916"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB516"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBell);
export default __webpack_public_path__ + "static/media/notification-bell.8fde7fb4cb95c5c2d516195ea9962558.svg";
export { ForwardRef as ReactComponent };